import styled from '@emotion/styled';

export const SearchIconWrapper = styled.div`
  padding-left: 4px;
`;
